<template>
    <div>
        <div class="card" v-if="sesion">
            <div class="card-header">
                <h3 class="card-title">
                    <div class="mb-2">
                        Entradas para la sesión: {{ sesion.fecha }}
                    </div>
                    <span class="red">*</span><strong>Arrastre los precios y haga clic en 'GUARDAR ORDEN' para ordenarlos</strong>
                </h3>
                <div class="card-tools">
                    <Button @click.prevent="showModal('crearEntrada')">Crear nueva entrada</Button>
                    <CreateModal 
                        :sesion="sesion" 
                        :evento_id="evento_id" 
                        v-on:close="closeModal"
                    />
                </div>
            </div>
            
            <div class="card-body">
                <draggable v-model="entradas" group="entradas" @end="onDragEnd" :delay="200">
                    <div v-for="(entrada) in entradas" :key="entrada.id" class="row mb-4 draggable-item">
                        <div :key="entrada.id + '_'" class="col-12 col-md-10">
                            <template v-if="entrada.descripcion != 'Invitación Protocolo'">
                                <h4><strong>{{ entrada.descripcion }}</strong></h4>
                                <div class="row">
                                    <div class="col-6 col-md-4">
                                        Entradas: {{ entrada.units }} <br />
                                        En sesión: {{ entrada.en_sesion }} <br />
                                        Disponibles: {{ entrada.units - entrada.en_sesion }}
                                    </div>
                                    <div class="col-6 col-md-4">
                                        Online: {{ entrada.price_management_online_interno == 1 ? parseFloat(entrada.precio) : parseFloat(entrada.precio) + parseFloat(entrada.price_management_online) | formatear_precio }} <br />
                                        Taquilla: {{ entrada.price_management_taquilla_interno == 1 ? parseFloat(entrada.precio) : parseFloat(entrada.precio) + parseFloat(entrada.price_management_taquilla) | formatear_precio }}
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div :key="entrada.id" class="col-12 col-md-2">
                            <div class="text-right">
                                <div>
                                    <OpcionesDropdownTableComponent 
                                        v-bind:options="[
                                            {
                                                type: 'action',
                                                action: () => showModal('editarEntrada-' + entrada.id, entrada),
                                                label: 'Editar',
                                            },
                                            {
                                                type: 'action',
                                                action: () => showModal('editarEntradaPuertas-' + entrada.id, entrada),
                                                label: 'Puertas',
                                            },
                                            {
                                                type: 'action',
                                                action: () => showModal('deleteEntrada-' + entrada.id, entrada),
                                                label: 'Borrar',
                                            },    
                                        ]" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
                <EditarModal v-if="entradaSeleccionada" :evento_id="evento_id" :sesion="sesion" :entrada="entradaSeleccionada" v-on:close="closeModal"/>
                <BorrarModal v-if="entradaSeleccionada" :evento_id="evento_id" :sesion_id="sesion.id" :entrada="entradaSeleccionada" v-on:close="closeModal"/>
                <PuertasModal v-if="entradaSeleccionada" :evento_id="evento_id" :sesion_id="sesion.id" :entrada="entradaSeleccionada" v-on:close="closeModal"/>
                <div v-if="guardar_orden" class="text-right">
                    <button type="button" class="btn btn-primary" @click="updateOrdenEntradas()">GUARDAR ORDEN</button>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="card-body">
                <LoaderComponent/>
            </div>
        </template>
    </div>
</template>

<script>
    import CreateModal from './modals/CreateEntradaSinRecinto';
    import EditarModal from './modals/EditarEntradaSinRecinto';
    import BorrarModal from './modals/DeleteEntradaSinRecinto';
    import PuertasModal from './modals/PuertasModal';
    import draggable from 'vuedraggable';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent.vue';

    export default {
        props: ['evento_id', 'sesion_id'],
        data() {
            return {
                expand: [],
                sesion: null,
                entradas: [],
                loading: true,
                guardar_orden: false,
                entradaSeleccionada: null
            }
        },
        created() {
            this.getSesion();
        },
        methods: {
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            showModal(modal, entrada) {
                this.entradaSeleccionada = entrada;
                setTimeout(() => {
                    this.$modal.show(modal);
                }, 100);
            },
            closeModal(modal, creado) {
                this.expand = [];

                if(creado) {
                    this.getSesion();
                }

                this.$modal.hide(modal);
            },
            getSesion : function() {
                this.loading = true;

                const params = {
                    filters : {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
                    this.sesion = res.data.data;
                    this.entradas = res.data.data.entradas;
                }).finally(() => this.loading = false);
            },
            onDragEnd() {
                this.guardar_orden = true;
            },
            updateOrdenEntradas() {
                const params = {
                    filters : {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    entradas: this.entradas
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.editar-orden'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getSesion();
                    this.guardar_orden = false;
                });
            },
        },
        components: {
            CreateModal, EditarModal, BorrarModal, PuertasModal, draggable, OpcionesDropdownTableComponent
        }
    }
</script>

<style scoped>
    .draggable-item {
        transition: background-color 0.3s;
    }

    .draggable-item:active {
        background-color: #f0f0f0;
    }

    .draggable-item:hover {
        cursor: grab;
    }

    .drag-handle {
        cursor: pointer;
    }
</style>
